module.exports = __webpack_public_path__ + "img/workflow-preview.34764778.svg";